import Globe from "./EntityMods/Globe";
const Race = () => {
    return (
        <div className="manage-body" style={{position:"absolute",width: window.innerWidth, height: window.innerHeight*0.82 }}>
            <Globe/>
        </div>
    );
}

export default Race;